var cilScreenDesktop = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M40,392H240v72H160v32H352V464H272V392H472a24.028,24.028,0,0,0,24-24V72a24.028,24.028,0,0,0-24-24H40A24.028,24.028,0,0,0,16,72V368A24.028,24.028,0,0,0,40,392ZM48,80H464V360H48Z' class='ci-primary'/>"];

export { cilScreenDesktop };

